import React from 'react';
import type { KpiItem } from '../../utils/kpis';
import { MetricInfoButton } from '../definitions/MetricInfoButton';
import { DeltaBadge } from './DeltaBadge';
export function KpiCard({
  item
}: {
  item: KpiItem;
}) {
  return <div className={`flex flex-col rounded-lg border bg-white px-4 py-3.5 ${item.emphasis ? 'border-navy/30' : 'border-line'}`} data-id="element-693" data-mp="216gttra3mcmr">
      <div className="flex items-start gap-1.5" data-id="element-694" data-mp="264a4awifpssu">
        <span className="text-[12.5px] font-medium leading-snug text-ink-muted" data-id="element-695" data-mp="2a6wy32yo1nso">{item.label}</span>
        <span className="mt-0.5" data-id="element-696" data-mp="2f5zs7sd3y9lv">
          <MetricInfoButton id={item.definitionId} label={item.label} data-id="element-697" data-mp="2f58a9kcfoae2" />
        </span>
      </div>
      <div className={`mt-2 font-semibold leading-none tracking-tight text-navy tabular-nums ${item.emphasis ? 'text-[28px]' : 'text-[24px]'}`} data-id="element-698" data-mp="2jyjgbj9f8n4x">{item.value}</div>
      {item.deltas.length > 0 && <div className="mt-3 flex flex-wrap gap-x-3 gap-y-1" data-id="element-699" data-mp="2txs6s252vjmj">
          {item.deltas.map(d => <DeltaBadge key={d.label} value={d.value} kind={d.kind} label={d.label} data-id="element-700" data-mp="2xxsktlo9lst2" />)}
        </div>}
      <div className="mt-auto truncate pt-2.5 text-[11px] text-ink-subtle" data-id="element-701" data-mp="1yqxsec1qden3">{item.caption}</div>
    </div>;
}